import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import { authGuard } from "../auth/authGuard"
import { adminAuthGuard } from "../auth/adminAuthGuard"
import Home from '@/components/Home'
import About from '@/components/About'
import Login from '@/components/Login'
// import LoginTemp from '@/components/LoginTemp'
import Signup from '@/components/Signup'
import AccountsDetail from '@/components/AccountsDetail'
import Contact from '@/components/Contact'
import Press from '@/components/Press'
import PressDetail from '@/components/PressDetail'
import Events from '@/components/Events'
import Gallery from '@/components/Gallery'
import Artists from '@/components/Artists'
import ArtistDetail from '@/components/ArtistDetail'
import Stages from '@/components/Stages'
import StagesTags from '@/components/StagesTags'
import StageDetail from '@/components/StageDetail'
import StageEdit from '@/components/StageEdit'
import StageCreate from '@/components/StageCreate'
import CreateUpcomingStage from '@/components/CreateUpcomingStage'
import AccountsDetailsForm from '@/components/AccountsDetailsForm'
import JoinStage from '@/components/JoinStage'
import Notification from '@/components/Notification'
import Sixftapart from '@/view/6ftapart'
import Campaign from '@/view/campaign'
import Message from '@/components/Message'
import ResetPassword from '@/components/ResetPassword'
import ForgotPassword from '@/components/ForgotPassword'


import UpcomingStageDetail from '@/components/UpcomingStageDetail'
import EditUpcomingStage from '@/components/EditUpcomingStage'

import EventCreate from '@/components/admin/event/Create'
import EventEdit from '@/components/admin/event/Edit'
import EventsList from '@/components/admin/event/List'
import ArtistList from '@/components/admin/artists/List'
import ArtistCreate from '@/components/admin/artists/Create'
import ArtistEdit from '@/components/admin/artists/Edit'
import ProfileEdit from '@/components/admin/profiles/Edit'
import StagesList from '@/components/admin/stages/List'
import StagesCreate from '@/components/admin/stages/Create'
import StagesEdit from '@/components/admin/stages/Edit'
import AdminEditUpcomingStage from '@/components/admin/stages/EditUpcomingStage'
import AdminCreateUpcomingStage from '@/components/admin/stages/CreateUpcomingStage'
import AdminLogin from '@/components/admin/Login'
import AdminPeopleCreate from '@/components/admin/people/Create'
import AdminPeople from '@/components/admin/people/List'
import AdminPeopleEdit from '@/components/admin/people/Edit'
import AdminPressCreate from '@/components/admin/press/Create'
import PressList from '@/components/admin/press/List'
import PressEdit from '@/components/admin/press/Edit'
import SixftapartList from '@/components/admin/6ftapart/List'

import AdminCampaignCreate from '@/components/admin/campaign/Create'
import AdminCampaignList from '@/components/admin/campaign/List'
import AdminSixftapartCreate from '@/components/admin/6ftapart/Create'

import inviteMembers from '@/components/include/inviteMembers'
import Chat from '@/components/include/Chat'

Vue.use(Router)

//add before enter to any route
// beforeEnter: authGuard

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about/',
      name: 'About',
      component: About
    },
    {
      path: '/chat/',
      name: 'Chat',
      component: Chat
    },
    {
      path: '/inviteMembers/',
      name: 'inviteMembers',
      component: inviteMembers
    },
    {
      path: '/login/',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup/',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/reset-password/',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/forgot-password/',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/accounts-detail/',
      name: 'AccountsDetail',
      component: AccountsDetail,
      beforeEnter: authGuard
    },
    {
      path: '/my-gallery/',
      name: 'Gallery',
      component: Gallery,
      beforeEnter: authGuard
    },
    {
      path: '/contact/',
      name: 'Contact',
      component: Contact
    },
    // {
    //   path: '/press/',
    //   name: 'Press',
    //   component: Press
    // },
    {
      path: '/press/:id/',
      name: 'PressDetail',
      component: PressDetail
    },
    {
      path: '/events/:id',
      name: 'Events',
      component: Events
    },
    {
      path: '/6ftapart/',
      name: 'sixFeetApart',
      component: Sixftapart
    },
    {
        path: '/campaign/:id',
        name: 'Campaign',
        component: Campaign
    },
    {
      path: '/artists/',
      name: 'Artists',
      component: Artists
    },
    {
      path: '/artists/:id/message',
      name: 'Message',
      component: Message
    },
    {
      path: '/artists/:id',
      name: 'ArtistDetail',
      component: ArtistDetail,
        meta: {
            title: 'About Page - Example App',
            metaTags: [
                {
                    name: 'description',
                    content: 'The about page of our example app.'
                },
                {
                    property: 'og:description',
                    content: 'The about page of our example app.'
                }
            ]
        }
    },
    {
      path: '/stages/',
      name: 'Stages',
      component: Stages
    },
    {
      path: '/stages/:id',
      name: 'StagesTags',
      component: StagesTags
    },
    {
      path: '/stage/create/',
      name: 'CreateUpcomingStage',
      component: CreateUpcomingStage,
      beforeEnter: authGuard
    },
    {
      path: '/stage/join-stage/',
      name: 'JoinStage',
      component: JoinStage,
      beforeEnter: authGuard
    },
    {
      path: '/stage/:id/',
      name: 'UpcomingStageDetail',
      component: UpcomingStageDetail
    },
    {
      path: '/stage/:id/edit/',
      name: 'EditUpcomingStage',
      component: EditUpcomingStage,
      beforeEnter: authGuard
    },
    // {
    //   path: '/upcoming-stage/create-stage',
    //   name: 'CreateUpcomingStage',
    //   component: CreateUpcomingStage
    // },
    // {
    //   path: '/upcoming-stage/:id',
    //   name: 'UpcomingStageDetail',
    //   component: UpcomingStageDetail
    // },
    {
      path: '/notification/',
      name: 'Notification',
      component: Notification,
      beforeEnter: authGuard
    },
    // {
    //   path: '/accounts-detail',
    //   name: 'AccountsDetailsForm',
    //   component: AccountsDetailsForm,
    //   beforeEnter: authGuard
    // },
    {
      path: '/admin/event/create',
      name: 'EventCreate',
      component: EventCreate,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/events',
      name: 'EventsList',
      component: EventsList,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/event/:id',
      name: 'EventEdit',
      component: EventEdit,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artists',
      name: 'ArtistList',
      component: ArtistList,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artist/create',
      name: 'ArtistCreate',
      component: ArtistCreate,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artist/:id',
      name: 'ArtistEdit',
      component: ArtistEdit,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artist/:userId/profile/:id',
      name: 'ProfileEdit',
      component: ProfileEdit,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artist/:id/stages',
      name: 'StagesList',
      component: StagesList,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artist/:id/stage/create',
      name: 'AdminCreateUpcomingStage',
      component: AdminCreateUpcomingStage,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/artist/:userId/stage/:id',
      name: 'AdminEditUpcomingStage',
      component: AdminEditUpcomingStage,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/people/create',
      name: 'AdminPeopleCreate',
      component: AdminPeopleCreate,
      beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/people',
      name: 'AdminPeople',
      component: AdminPeople,
      beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/people/:id/edit',
        name: 'AdminPeopleEdit',
        component: AdminPeopleEdit,
        beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/press/create',
        name: 'AdminPressCreate',
        component: AdminPressCreate,
        beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/press',
        name: 'PressList',
        component: PressList,
        beforeEnter: adminAuthGuard
    },
    // {
    //     path: '/admin/6ftapartList',
    //     name: 'SixftapartList',
    //     component: SixftapartList,
    //     beforeEnter: adminAuthGuard
    // },
    // {
    //     path: '/admin/6ftapart/create',
    //     name: 'AdminSixftapartCreate',
    //     component: AdminSixftapartCreate,
    //     beforeEnter: adminAuthGuard
    // },
    {
        path: '/admin/campaign/create',
        name: 'AdminCampaignCreate',
        component: AdminCampaignCreate,
        beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/campaign/:id/create',
        name: 'AdminSixftapartCreate',
        component: AdminSixftapartCreate,
        beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/campaign/:id',
        name: 'SixftapartList',
        component: SixftapartList,
        beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/campaigns',
        name: 'AdminCampaignList',
        component: AdminCampaignList,
        beforeEnter: adminAuthGuard
    },
    {
        path: '/admin/press/:id',
        name: 'PressEdit',
        component: PressEdit,
        beforeEnter: adminAuthGuard
    },
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: AdminLogin
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    this.seen = false
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js